module.exports = __webpack_public_path__ + "img/orange-circle-table-3.c79431f8.png";